import React from "react";
import ReactDOM from "react-dom/client";
import localforage from "localforage";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";

import ErrorPage from "core/ErrorPage";
import { APPVER, LS_NAME, LS_STORE } from "core/Constants";

// Importing the CSS
import "./styles/reset.css";
import "./styles/index.css";

import Login from "core/Login";
import ResetPassword from "core/ResetPassword";
import ProtectedRoute from "core/ProtectedRoute";
import Dashboard from "components/dashboards/Dashboard";
import Reports from "components/common/reports/Reports";
import MonitoringReport from "components/common/reports/MonitoringReport";
import UserManagement from "components/common/user-management/UserManagement";
import Subscription from "components/common/subscription/Subscription";
import Support from "components/common/query-support/Support";
import SummaryReport from "components/common/reports/SummaryReport";
import SubscriptionListing from "components/common/subscription/SubscriptionListing";
import NewSubscription from "components/common/subscription/NewSubscription";
import FeedMissing from "components/common/reports/FeedMissing";
import Masters from "components/admin/masters/Masters";
import BrandMaster from "components/admin/masters/BrandMaster";
import ChannelMaster from "components/admin/masters/ChannelMaster";
import ContentLanguage from "components/admin/masters/ContentLanguageMaster";
import GenreMaster from "components/admin/masters/GenreMaster";
import ProgramMaster from "components/admin/masters/ProgramMaster";
import Billing from "components/admin/billing/Billing";
import Clients from "components/admin/clients/Clients";
import FileDetails from "components/admin/file/FileDetails";
import ActivityTracker from "components/admin/activity/ActivityTracker";
import QueryExecutor from "components/admin/query/QueryExecutor";
import PromoMaster from "components/admin/masters/PromoMaster";
import ClientListing from "components/admin/clients/ClientListing";
import NewClient from "components/admin/clients/NewClient";
import GroupListing from "components/admin/clients/GroupListing";
import GroupAdvertisers from "components/admin/clients/GroupAdvertisers";
import AdHocReport from "components/common/reports/AdHocReport";
import Notification from "components/admin/notification/Notification";
import AccountManagers from "components/common/user-management/AccountManagers";
import RateCard from "components/admin/billing/RateCard";
import BillingDetails from "components/admin/billing/BillingDetails";
import ClientRenewalList from "components/admin/client_renewal/ClientRenewalList";
import GroupClientRenewalList from "components/admin/client_renewal/GroupClientRenewal";
// Initialize localforage
localforage.config({
  driver: localforage.INDEXEDDB,
  name: LS_NAME,
  version: 1.0,
  storeName: LS_STORE,
  description: "localstorage using localforage",
});

console.log(`App ver: ${APPVER}`);

// CSR
const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "reports",
        element: <Reports />,
        children: [
          {
            path: "",
            element: <Navigate to="monitoring" replace />,
          },
          {
            path: "monitoring",
            element: <MonitoringReport />,
          },
          {
            path: "adhoc",
            element: <AdHocReport />,
          },
          {
            path: "summary",
            element: <SummaryReport />,
          },
          {
            path: "multiadvertiser",
            element: <></>,
          },
          {
            path: "feedmissing",
            element: <FeedMissing />,
          },
        ],
      },
      {
        path: "masters",
        element: <Masters />,
        children: [
          {
            path: "",
            element: <Navigate to="brand" replace />,
          },
          {
            path: "brand",
            element: <BrandMaster />,
          },
          {
            path: "channel",
            element: <ChannelMaster />,
          },
          {
            path: "language",
            element: <ContentLanguage />,
          },
          {
            path: "genre",
            element: <GenreMaster />,
          },
          {
            path: "program",
            element: <ProgramMaster />,
          },
          {
            path: "promo",
            element: <PromoMaster />,
          },
        ],
      },
      {
        path: "account-managers",
        element: <AccountManagers />,
      },
      {
        path: "users",
        element: <UserManagement />,
      },
      {
        path: "subscriptions",
        element: <Subscription />,
        children: [
          {
            path: "",
            element: <Navigate to="listing" replace />,
          },
          {
            path: "listing",
            element: <SubscriptionListing />,
          },
          {
            path: "new",
            element: <NewSubscription />,
          },
        ],
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "billing",
        element: <Billing />,
        children: [
          {
            path: "",
            element: <Navigate to="rate-card" replace />,
          },
          {
            path: "rate-card",
            element: <RateCard />,
          },
          {
            path: "listing",
            element: <BillingDetails />,
          },
        ],
      },
      {
        path: "clients",
        element: <Clients />,
        children: [
          {
            path: "",
            element: <Navigate to="all" replace />,
          },
          {
            path: "group-advertisers",
            element: <GroupAdvertisers />,
          },
          {
            path: "groups",
            element: <GroupListing />,
          },
          {
            path: "all",
            element: <ClientListing />,
          },
          {
            path: "new",
            element: <NewClient />,
          },
          {
            path:"renewList",
            element:<ClientRenewalList/>,
          },
          {
            path:"GrpRenewList",
            element:<GroupClientRenewalList/>,
          }
        ],
      },
      {
        path: "file",
        element: <FileDetails />,
      },
      {
        path: "notification",
        element: <Notification />,
      },
      {
        path: "activity",
        element: <ActivityTracker />,
      },
      {
        path: "queryex",
        element: <QueryExecutor />,
      }
    ],
  },
   {
    path: "/login",
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
    errorElement: <ErrorPage />,
  }
]);

// React render
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
